import Sketch from 'sketch-lite';
import security from 'stores/security';
import type { FileUploaderBucketType } from 'types/common';
import API from 'utils/API';
import http from 'utils/http';
import { IAcceptItem, IUploaderType } from './types';

const imgExt = ['jpg', 'jpeg', 'png', 'gif', 'webp'];

// 通过type属性获取文件类型的配置属性
export function getAcceptsConfig(type: IUploaderType) {
    if (type === 'deposit') {
        return {
            accepts: [
                { accept: 'image/*', ext: imgExt },
                {
                    accept: 'application/pdf',
                    ext: ['pdf'],
                    maxSize: 5 * 1024 * 1024,
                    maxSizeText: __('文件需小于5M')
                }
            ],
            allowText: __('仅允许上传图片或PDF文件'),
            descriptionText: __('最多可上传6张图片或文件<br/>单个文件需小于5M')
        };
    }

    return {
        accepts: [{ accept: 'image/*', ext: imgExt }],
        allowText: __('仅允许上传图片'),
        descriptionText: ''
    };
}

// 获取input标签的accept属性
export function getInputAcceptProp(accepts: IAcceptItem[], isMobile?: boolean) {
    if (isMobile) {
        return '';
    }

    let acceptStr = '';

    for (const item of accepts) {
        acceptStr += `${item.accept},`;
    }

    return acceptStr;
}
/* istanbul ignore next */
/**
 * 压缩图片尺寸
 * @param {FILE} file 要压缩的图片文件
 * @param {Boolean} isCompress 是否压缩
 *
 * @return {Promise}
 *
 * ios系统上貌似超过2m的图片会写入canvas失败，所以压缩这一步貌似不行？？？
 */
export const compressImage = file => {
    return new Promise((resolve, reject) => {
        // 如果浏览器不支持相关接口，就返回原文件
        // @ts-ignore
        if (!window.FileReader) {
            return resolve(file);
        }

        if (!(file.type || '').startsWith('image')) {
            return resolve(file);
        }

        let forceFlag = true;

        const filename = file.name.split('.').slice(0, -1).join('.');

        if (/\.(jpe?g|png)/i.test(file.name)) {
            forceFlag = false;
        }

        const cimage = new Image();
        const fileReader = new FileReader();

        fileReader.onload = ev => {
            // @ts-ignore
            cimage.src = ev.target.result!;
        };

        fileReader.readAsDataURL(file);

        const MAX_SIZE = 2000;

        cimage.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d')!;
            const imgRatio = cimage.height / cimage.width;

            // 如果图片大小超出限定，则对图片进行裁剪
            if (cimage.height > MAX_SIZE || cimage.width > MAX_SIZE) {
                if (imgRatio < 1) {
                    canvas.width = MAX_SIZE;
                    canvas.height = MAX_SIZE * imgRatio;
                } else {
                    canvas.height = MAX_SIZE;
                    canvas.width = MAX_SIZE / imgRatio;
                }
            } else {
                if (!forceFlag) {
                    return resolve(file);
                }

                // webp需转换成jpeg内容
                canvas.width = cimage.width;
                canvas.height = cimage.height;
            }

            // 居中将图片写入画布
            ctx.drawImage(cimage, 0, 0, canvas.width, canvas.height);

            // 对图片格式进行处理，转为image/jpeg
            Sketch.prototype.toBlob.call(
                {
                    canvas,
                    toDataUrl(type) {
                        return canvas.toDataURL(type);
                    }
                },
                pic => {
                    pic.name = `${filename}.jpg`;
                    resolve(pic);
                },
                'image/jpeg'
            );
        };

        cimage.onerror = () => {
            reject(new Error(__('抱歉，图片格式暂不支持，请上传 jpg, jpeg, png, webp 格式的图片')));
        };
    });
};

export function uploadPic(data, bucket: FileUploaderBucketType, onProgress?: (progress: number) => void) {
    // 这里就是compose_id不是customer_id
    data.append('compose_id', security.currentCustomerId);

    return http.post<{
        url: string;
        filename: string;
    }>(API.CUSTOMER.uploadPic(bucket), data, {
        useJson: true,
        timeout: 60000,
        onUploadProgress(ev) {
            if (onProgress) {
                onProgress(Math.floor((ev.loaded / ev.total) * 100));
            }
        }
    });
}
